import { render, staticRenderFns } from "./ApprovalPerusahaan.vue?vue&type=template&id=5c9fd228&scoped=true"
import script from "./ApprovalPerusahaan.vue?vue&type=script&lang=js"
export * from "./ApprovalPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPerusahaan.vue?vue&type=style&index=0&id=5c9fd228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9fd228",
  null
  
)

export default component.exports